import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=05a89ea1&scoped=true&lang=pug&"
import script from "./Reset.vue?vue&type=script&lang=ts&"
export * from "./Reset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a89ea1",
  null
  
)

export default component.exports